import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiMembersSkillEvaluationStandardSummaryCategoryShowType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiMembersSkillEvaluationStandardSummaryCategoryShowType> => {
  const response =
    await new ApiClient().get<ApiMembersSkillEvaluationStandardSummaryCategoryShowType>(
      `/api/members/skill_evaluation_standard_summary_categories/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersSkillEvaluationStandardSummaryCategoriesShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMembersSkillEvaluationStandardSummaryCategoryShowType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersSkillEvaluationStandardSummaryCategoriesShow", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
